import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
// eslint-disable-next-line no-unused-vars
import { db, functions } from '../firebaseConfig';
import { httpsCallable } from 'firebase/functions';
// eslint-disable-next-line no-unused-vars
import { doc, updateDoc } from 'firebase/firestore';

import { IoArrowBack, IoSaveOutline, IoInformationCircleOutline, IoDocumentTextOutline } from 'react-icons/io5';
import './DatosFiscalesScreen.css';

function DatosFiscalesScreen() {
    const navigate = useNavigate();
    const { userData, currentUser, refreshUserData } = useAuth();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        rfc: '',
        razonSocial: '',
        regimenFiscal: '',
        cp: '',
        email: '',
        facturarAPropietario: false
    });

    // Populate with existing data if available
    useEffect(() => {
        if (userData?.datosFiscales) {
            setFormData({
                rfc: userData.datosFiscales.rfc || '',
                razonSocial: userData.datosFiscales.razonSocial || '',
                regimenFiscal: userData.datosFiscales.regimenFiscal || '',
                cp: userData.datosFiscales.cp || '',
                email: userData.datosFiscales.email || currentUser?.email || '',
                facturarAPropietario: userData.datosFiscales.facturarAPropietario || false
            });
        } else {
            setFormData(prev => ({
                ...prev,
                email: currentUser?.email || ''
            }));
        }
    }, [userData, currentUser]);

    const regimenes = [
        { id: '605', label: '605 - Sueldos y Salarios' },
        { id: '612', label: '612 - Personas Físicas con Actividades Empresariales' },
        { id: '626', label: '626 - Régimen Simplificado de Confianza (RESICO)' },
        { id: '601', label: '601 - General de Ley Personas Morales' },
        { id: '603', label: '603 - Personas Morales con Fines no Lucrativos' },
        { id: '621', label: '621 - Incorporación Fiscal' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'rfc' ? value.toUpperCase() : value
        }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Basic Validation
        const rfcRegex = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
        if (!rfcRegex.test(formData.rfc)) {
            alert("El RFC no tiene un formato válido.");
            setLoading(false);
            return;
        }

        try {
            const saveFiscalFn = httpsCallable(functions, 'saveResidentFiscalData');
            await saveFiscalFn({
                userId: currentUser.uid,
                condominioId: userData.condominioId,
                ...formData
            });
            await refreshUserData(); // Refresh context
            alert("¡Datos validos! Registro Exitoso en Facturapi.");
            navigate(-1);

        } catch (error) {
            console.error("Backend Error:", error);
            // DISABLE FRONTEND SIMULATION FALLBACK TO SEE REAL ERROR
            alert("Error al guardar (Facturapi): " + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="datos-fiscales-container">
            {/* Premium Header Banner */}
            <div style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', position: 'relative', overflow: 'hidden', padding: '25px', borderRadius: '15px', marginBottom: '30px', boxShadow: '0 4px 15px rgba(29, 78, 216, 0.2)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', zIndex: 2, position: 'relative' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <button type="button" onClick={() => navigate(-1)} style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(5px)', border: 'none', borderRadius: '50%', width: '42px', height: '42px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', transition: 'background 0.2s', color: 'white', flexShrink: 0 }}>
                            <IoArrowBack size={22} />
                        </button>
                        <div style={{ marginTop: '0' }}>
                            <h1 style={{ color: 'white', margin: '0 0 5px', fontSize: '1.6rem', fontWeight: '800' }}>Datos de Facturación</h1>
                            <p style={{ color: 'rgba(255, 255, 255, 0.9)', margin: 0, fontSize: '0.9rem', fontWeight: '500' }}>Configuración de CFDI 4.0</p>
                        </div>
                    </div>
                </div>
                {/* Decoración de fondo */}
                <div style={{ position: 'absolute', right: '-25px', bottom: '-40px', zIndex: 0, pointerEvents: 'none', transform: 'rotate(-10deg)', opacity: 0.15 }}>
                    <IoDocumentTextOutline size={180} color="white" />
                </div>
            </div>

            <div className="df-card">
                <div className="df-info-box">
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <IoInformationCircleOutline size={24} color="#3b82f6" />
                        <span className="df-info-text">
                            Estos datos se utilizarán para generar automáticamente tus facturas (CFDI 4.0) cuando realices el pago de tus cuotas.
                        </span>
                    </div>
                </div>

                <form onSubmit={handleSave}>
                    <div className="df-form-group">
                        <label className="df-label">RFC</label>
                        <input
                            name="rfc"
                            value={formData.rfc}
                            onChange={handleInputChange}
                            className="df-input"
                            placeholder="RFC (con Homoclave)"
                            maxLength={13}
                            required
                        />
                    </div>

                    <div className="df-form-group">
                        <label className="df-label">Razón Social</label>
                        <input
                            name="razonSocial"
                            value={formData.razonSocial}
                            onChange={handleInputChange}
                            className="df-input"
                            placeholder="Nombre completo o Razón Social"
                            required
                        />
                    </div>

                    <div className="df-form-group">
                        <label className="df-label">Régimen Fiscal</label>
                        <select
                            name="regimenFiscal"
                            value={formData.regimenFiscal}
                            onChange={handleInputChange}
                            className="df-select"
                            required
                        >
                            <option value="">Seleccione...</option>
                            {regimenes.map(r => (
                                <option key={r.id} value={r.id}>{r.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="df-form-group">
                        <label className="df-label">Código Postal</label>
                        <input
                            name="cp"
                            value={formData.cp}
                            onChange={handleInputChange}
                            className="df-input"
                            placeholder="Código Postal Fiscal"
                            maxLength={5}
                            type="number"
                            required
                        />
                    </div>

                    <div className="df-form-group">
                        <label className="df-label">Email para envío de Facturas</label>
                        <input
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="df-input"
                            required
                        />
                    </div>

                    {userData?.tipoResidente === 'Propietario' && (
                        <div className="df-form-group" style={{ marginTop: '20px', padding: '15px', backgroundColor: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
                            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer', margin: 0 }}>
                                <input
                                    type="checkbox"
                                    name="facturarAPropietario"
                                    checked={formData.facturarAPropietario}
                                    onChange={(e) => setFormData(prev => ({ ...prev, facturarAPropietario: e.target.checked }))}
                                    style={{ width: '20px', height: '20px', marginTop: '2px', flexShrink: 0 }}
                                />
                                <span style={{ color: '#1e40af', fontSize: '0.95em', lineHeight: '1.4' }}>
                                    <strong>Facturación Centralizada:</strong><br />
                                    Deseo que todas las facturas de gastos de mi unidad (incluyendo los pagos de mis inquilinos o familiares) se emitan automáticamente a mi nombre con estos datos fiscales.
                                </span>
                            </label>
                        </div>
                    )}

                    <button type="submit" className="df-save-btn" disabled={loading}>
                        {loading ? 'Guardando...' : (
                            <>
                                <IoSaveOutline size={20} />
                                Guardar Datos
                            </>
                        )}
                    </button>

                    <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f3f4f6', borderRadius: '5px', fontSize: '0.8em', color: '#666' }}>
                        <p><strong>Debug Info:</strong></p>
                        <p>ID Condominio: {userData?.condominioId}</p>
                        <p>ID Cliente Facturapi: {userData?.datosFiscales?.facturapiCustomerId || 'No registrado'}</p>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default DatosFiscalesScreen;
